import { createContext, useContext, useState, useCallback } from 'react';

// ── UI Context ──────────────────────────────────────────────────────
const UIContext = createContext(null);

export function UIProvider({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((msg, type = 'info', duration = 3500) => {
    const id = Date.now();
    setToasts((p) => [...p, { id, msg, type }]);
    setTimeout(() => setToasts((p) => p.filter((t) => t.id !== id)), duration);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((p) => p.filter((t) => t.id !== id));
  }, []);

  return (
    <UIContext.Provider value={{ sidebarOpen, setSidebarOpen, toasts, addToast, removeToast }}>
      {children}
    </UIContext.Provider>
  );
}

export const useUI = () => useContext(UIContext);

// ── Notification Context ────────────────────────────────────────────
const NotifContext = createContext(null);

export function NotifProvider({ children }) {
  const [unreadCount, setUnreadCount] = useState(0);
  return (
    <NotifContext.Provider value={{ unreadCount, setUnreadCount }}>
      {children}
    </NotifContext.Provider>
  );
}

export const useNotif = () => useContext(NotifContext);
